import Button from "../../Elements/Button/Button.js";
import Image from "../../Elements/Image/Image.tsx";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../contexts/userContext/userContext.js";

const NotEnoughSpaceModal = () => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const { isBusiness,isPremium} = useUser();

  return (
    <div className="not-enough-space-modal">
      <div className="top-section">
        <Image name="storage-files" ext="png" />
        <div className="title">{getTextByKey("not-enough-space-title")}</div>
        <div className="content-text">
          {getHtmlByKey("not-enough-space-text")}
        </div>
      </div>
      <div className="bottom-section">
        {isBusiness() || isPremium() ? null : (
          <Button>
            <LinkToNewTab page="plans" isNewTab={true}>
              {getTextByKey("upgrade")}
            </LinkToNewTab>
          </Button>
        )}
        <Button blank>
          <LinkToNewTab page="inbox" isNewTab={true}>
            {getTextByKey("not-enough-space-remove-items")}
          </LinkToNewTab>
        </Button>
      </div>
    </div>
  );
};

export default NotEnoughSpaceModal;
